import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { GuidaLabel } from '@inter-ikea-guida/framework';
import { SkapaText, SkapaTokens } from '@inter-ikea-guida/skapa';
import { useKompis } from '../../contexts';
import { useIsMetricMeasures } from '../../hooks/useIsMetricMeasures';
import { getTranslation } from '../../store/i18n/selectors';
import { OPTION_TYPE_MEASUREMENT } from '../../utils';
import { getFormattedMeasurement } from '../common/FormattedMeasurement';
const StyledContainer = styled.div `
  margin-bottom: ${SkapaTokens.space100};
`;
/**
 * Readonly representation of a form element, will only render plain text.
 */
export const ReadOnlyFormOption = ({ label, option }) => {
    const translate = useSelector(getTranslation);
    const useMetricMeasures = useIsMetricMeasures();
    const { translations } = useKompis();
    return (_jsxs(StyledContainer, { children: [_jsx(GuidaLabel, { text: translate(label) }), _jsx(SkapaText, { textStyle: 'Body.L', tagName: 'span', children: option.type === OPTION_TYPE_MEASUREMENT
                    ? getFormattedMeasurement(parseInt(option.value, 10), translate, !useMetricMeasures, false, translations.kompis)
                    : translate(option.label) })] }));
};
//# sourceMappingURL=ReadOnlyFormOption.js.map